module.exports = "./img/da8dbc7451c1e276bfbbe536c3541198.png";